import React, { useEffect, useState } from 'react'
import { TableFromApiCP } from 'submodules/nerit-framework-ui/common/components/table/TableFromApiCP'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'
import { ButtonGroupCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonGroupCP'
import { ButtonDeleteRecordCP } from 'submodules/nerit-framework-ui/common/components/table/columns/ButtonDeleteRecordCP'
import { RegulationRequests } from 'submodules/nerit-aquatec-sdk/services/regulation/RegulationRequests'
import { RegulationResponseDTO } from 'submodules/nerit-aquatec-sdk/services/regulation/dtos/responses/RegulationResponseDTO'
import { ButtonModalRegulationCP } from 'modules/fields/components/buttons/button-modal-regulation/ButtonModalRegulationCP'
import { PermissionEnum } from 'submodules/nerit-aquatec-sdk/services/auth/authenticate/enums/PermissionEnum'
import { AccessControlCP } from 'app/components/access-control/AccessControlCP'

interface ICPProps {
    shouldLoadData: number
}

export function TableRegulationsCP(props: ICPProps): JSX.Element {

    const [shouldLoadData, setShouldLoadData] = useState<number>(props.shouldLoadData)
    useEffect(() => setShouldLoadData(props.shouldLoadData), [props.shouldLoadData])

    return (
        <TableFromApiCP<RegulationResponseDTO>
            apiConfig={{
                hasPagination: true,
                requestConfigTP: RegulationRequests.search
            }}
            appearance={{
                showReloadButton: true,
                wrappedOnCard: true,
                showTotalOnHeader: true,
            }}
            shouldLoadData={shouldLoadData}
            columns={[
                {
                    title: '#',
                    render: (text, record) => record.code
                },
                {
                    title: 'Nome',
                    render: (text, record) => record.name
                },
                {
                    title: 'Classe',
                    render: (text, record) => record.class
                },
                {
                    title: 'Descrição',
                    render: (text, record) => record.description
                },
                {
                    render: (text, record) =>
                        <AccessControlCP permission={PermissionEnum.ROLE_ADMIN}>
                            <ButtonGroupCP mode={'separeted'}>
                                <ButtonModalRegulationCP
                                    onSave={() => setShouldLoadData(TableUtils.getReloadNumber())}
                                    regulation={record}
                                    buttonSize={'small'}
                                />
                                <ButtonDeleteRecordCP
                                    requestConfigTP={() => RegulationRequests.delete(record.code)}
                                    onDelete={() => setShouldLoadData(TableUtils.getReloadNumber())}
                                />
                            </ButtonGroupCP>
                        </AccessControlCP>
                }
            ]}
        />
    )
}
